import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const numberOfChildren: AnswerPathTreeNode = { path: 'numberOfChildren', nodeId: NodeIds.numberOfChildren };
